var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 112,
    viewBox: "0 0 115 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8628 0L18.3284 11.483L6.79046 0L1.49854 5.26937L13.0384 16.7524L1.49854 28.2335L6.79046 33.5029L18.3284 22.0199L29.8628 33.5029L35.1565 28.2335L23.6204 16.7524L35.1565 5.26937L29.8628 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.69 88.4876L84.1539 77.0046L78.8601 82.274L90.3962 93.7552L78.8601 105.236L84.1539 110.508L95.69 99.0245L107.226 110.508L112.518 105.236L100.982 93.7552L112.518 82.274L107.226 77.0046L95.69 88.4876Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3273 82.6646C24.472 82.6646 29.4711 87.6406 29.4711 93.7589C29.4711 99.8735 24.472 104.849 18.3273 104.849C12.1825 104.849 7.18347 99.8735 7.18347 93.7589C7.18347 87.6406 12.1825 82.6646 18.3273 82.6646ZM33.7888 72.6099C38.4747 65.474 43.8329 58.8387 49.7143 52.8928C64.9859 37.4532 82.1713 28.218 100.821 25.4202L91.394 40.2492L97.8003 44.3342L114.332 18.3283L88.2405 1.85834L84.1919 8.28829L99.4783 17.9341C79.2684 21.0089 60.7126 30.9682 44.3137 47.5501C38.0787 53.8517 32.4018 60.8812 27.4414 68.4406C26.2699 70.2209 25.1611 72.0066 24.1425 73.7503L23.332 75.1602C21.8069 74.7678 20.2486 74.5698 18.6884 74.5698C8.38456 74.5698 0 82.9653 0 93.284C0 103.605 8.38456 112 18.6884 112C28.9942 112 37.3787 103.605 37.3787 93.284C37.3787 87.5251 34.6913 82.0632 30.1546 78.5228L30.7016 77.5767C31.6503 75.9614 32.6891 74.2893 33.7888 72.6099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.03260ddd32254fb34a090c2e5cbce428.svg";
export { ForwardRef as ReactComponent };